import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ReactGA from 'react-ga';

import FieldGroupComponent from '../../core/FieldGroupComponent/FieldGroupComponent';
import LicensesContainer from '../../../containers/LicensesContainer';
import TeamMembersContainer from '../../../containers/TeamMembersContainer';

import './licensesTeam.scss';

class LicensesTeamComponent extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);

        this.state = {
            modalTitle: '',
            modalMessage: '',
            modalBody: '',
            modalConfirmButtonTitle: 'Yes',
            modalCancelButtonTitle: 'No',
            modalOnConfirm: () => {},
            showModal: false,
            isDev: true,
        };
    }

    handleClick = (environment) => {
        ReactGA.event({
            category: 'Licenses Component',
            action: 'Clicked ' + environment + ' environment',
            label: 'Toggle',
        });

        let develement = document.getElementById('dev');
        let prodelement = document.getElementById('prod');
        if (environment === 'dev') {
            this.setState({
                isDev: true,
            });
            develement.classList.add('active');
            prodelement.classList.remove('active');
        } else {
            this.setState({
                isDev: false,
            });
            prodelement.classList.add('active');
            develement.classList.remove('active');
        }
    }

    render() {
        const {
            licenses,
            companies,
            onCompanySelect,
            getMembers,
            getLicenses,
            isLoading,
            currentCompanyId,
        } = this.props;
        let companyNames = companies.map(({ name, firebaseId }, index) => {
            return { label: name, value: firebaseId };
        });
        return <div className="licenses-team-container">
            <div>
                <h3 className="company-heading">Company</h3>
                <FieldGroupComponent
                    name="listofCompanies"
                    type="select"
                    formProps={{
                        id: 'listofCompanies',
                        label: 'List of Companies',
                        options: companyNames,
                        onCompanySelect: onCompanySelect,
                        getMembers: getMembers,
                        isLoading: isLoading,
                        getLicenses: getLicenses,
                    }}
                    className="company-select"
                />
                <Button className="environment-dev active" id="dev" onClick={() => this.handleClick('dev')}>DEV ({(licenses.dev.length + licenses.prod.length)})</Button>
                <Button className="environment-prod" id="prod" onClick={() => this.handleClick('prod')}>PROD ({licenses.prod.length})</Button>
            </div>
            {currentCompanyId &&
                <LicensesContainer isDev={this.state.isDev} backToDevelopment={this.handleClick} />
            }
            <br />
            {currentCompanyId &&
                <TeamMembersContainer />
            }
        </div>;
    }
}

LicensesTeamComponent.propTypes = {
    licenses: PropTypes.object,
    companies: PropTypes.array.isRequired,
    onCompanySelect: PropTypes.func.isRequired,
    getMembers: PropTypes.func.isRequired,
    getLicenses: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    currentCompanyId: PropTypes.string,
};

export default LicensesTeamComponent;



// WEBPACK FOOTER //
// ./src/components/profile/LicensesTeam/LicensesTeamComponent.js